import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CustomTable from "../../../../components/custom-table/custom-table";
import { LoaderMessage } from "../../../../components/loaderMessage/loaderMessage";
import { RootState } from "../../../../redux/store/store";
import {
  DrugTableForExternalColumnsKeys,
  generateDrugTableForExternalData,
} from "./utils/generateTableDataForExternal";

const DrugTableForExternal = () => {
  const { orderId } = useParams();
  const { singleMedicalPaOrder, isLoading } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );

  const { data: authStatusOptions } = useSelector(
    (state: RootState) => state.authStatusOptions,
  );

  const [tableData, setTableData] = useState<any[]>([]);

  useEffect(() => {
    if (singleMedicalPaOrder) {
      let generatedData = generateDrugTableForExternalData(
        singleMedicalPaOrder,
        authStatusOptions ?? [],
      );
      setTableData(generatedData);
    }
  }, [singleMedicalPaOrder, orderId]);

  const renderTextWithProperIndentation = (text: string) => {
    const formattedText = (text ?? "N/A").replace(/\\n/g, "\n");
    return (
      <>
        {formattedText.split(/\n{2,}/).map((paragraph, index) => (
          <p key={index} className="mb-4">
            {paragraph.split("\n").map((line, i, arr) => (
              <React.Fragment key={i}>
                {line}
                {i < arr.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        ))}
      </>
    );
  };

  const getAllEvidenceText = useMemo(() => {
    // Special case for specific order ID
    if (orderId === "7d5b393e-83de-4380-b5e4-90c82acc4620") {
      return "Lupron Depot : C61& Case has been approved for J9217 with PA#242811925  for 4 visits from 10/05/2024 to 10/05/2025 as per portal_SN (ID-74162647700) under Leiton Chavarria, Jose";
    }

    if (singleMedicalPaOrder?.auth_on_file) {
      const authEntries = singleMedicalPaOrder?.auth_on_file?.auth_entries;
      if (authEntries) {
        return authEntries.map((entry) => entry.evidences).join("\n\n");
      }
    }
    return "";
  }, [singleMedicalPaOrder, orderId]);

  return (
    <div className="cpt-codes-table--container flex h-full flex-col">
      {isLoading ? (
        <LoaderMessage message={"Fetching CPT Codes"} />
      ) : (
        <>
          <div className="table-drug-template rounded-lg bg-primaryGray-16 p-3 text-h12">
            {renderTextWithProperIndentation(getAllEvidenceText ?? "")}
          </div>
          <CustomTable
            tableHeaders={DrugTableForExternalColumnsKeys}
            tableData={tableData}
            itemsPerPage={tableData.length}
            pagesPerView={5}
            count={tableData.length}
            onRowClick={() => {}}
            tableName="cptCodes"
            hideSearchBar={true}
            hidePagination={true}
          />
        </>
      )}
    </div>
  );
};

export default DrugTableForExternal;
